import axios from 'axios';
import {
  ADD_TO_CART,
  CLEAN_CART,
  EDIT_CART_QUANTITY,
  GET_CART_FROM_STORAGE,
  REMOVE_FROM_CART,
  ATTACH_SHIPMENT_INFO,
  PROCESS_CART_PURCHASE, USER_AUTH_SUCCESS
} from "@/store/mutation-types";
import Api from "@/Api";

const state = {
  total: 0,
    subtotal: 0,
    discount_value: 0,
  items:[],
  shipment:{
    forma_envio:'',
    envio_observacion:'',
  },
  paymentType:'TR',
  user: JSON.parse(localStorage.getItem('gorsh_user')) || {}
};

const getters = {
  cart_total: state => state.total,
    cart_subtotal: state => state.subtotal,
  cart_items: state => state.items,
  shipment: state => state.shipment,
  payment: state => state.paymentType,
    discount_value: state => state.discount_value
};

const actions = {
  loadCartFromStorage(store, { product }) {
    return new Promise((resolve, reject) => {
      store.commit(GET_CART_FROM_STORAGE, {});
      resolve(product);
    });
  },

  editCartQuantity(store,{bindItem,quantity}){

    return new Promise((resolve, reject) => {
      let item = store.commit(EDIT_CART_QUANTITY, { item:bindItem, quantity: quantity});
      resolve(true);
    });
  },

  addToCart (store, { product,quantity }) {


    return new Promise((resolve, reject) => {

      if (!quantity)quantity=1;

      var record = state.items.find(p => p.product.id === product.id);


      if (record) {
        var newQuantity = parseInt(parseInt(record.quantity) + parseInt(quantity));

        if (record.product.stock_unico<newQuantity)
          reject(new Error("La cantidad supera el stock Máximo: " + record.product.stock_unico));
      }



      let item = store.commit(ADD_TO_CART, { product: product, quantity: quantity});
      resolve(state.items[state.items.length-1]);


    });

  },

  cleanCart(store){
    return new Promise((resolve, reject) => {
      store.commit(CLEAN_CART, { });
      resolve(true);
    });
  },

  removeFromCart(store,{item}){
      return new Promise((resolve, reject) => {
        store.commit(REMOVE_FROM_CART, { product: item});
        resolve(true);
      });

  },

  attachShipment(store,{shipment}){
    return new Promise((resolve, reject) => {
      store.commit(ATTACH_SHIPMENT_INFO, { shipment: shipment});
      resolve(true);
    });
  },
  processCartPurchase(store,{order}){
    return new Promise((resolve, reject) => {

      Api().post('?func=placeOrder', order)
        .then(({ data }) => {
          if (data.success) {
            store.commit(PROCESS_CART_PURCHASE, {});
            resolve();
          } else {
            reject(data.error.message);
          }
        }).catch(() => {
          reject('No pudimos conectarnos con el servidor!');
        });
    });
  }


};

const mutations = {
  [CLEAN_CART] (store, { }) {
    store.items = [];
    store.total = 0;
      store.subtotal = 0;
      store.discount_value = 0;
    localStorage.removeItem('cart');
  },
  [GET_CART_FROM_STORAGE] (store, { product, quantity}) {
    var items = JSON.parse(localStorage.getItem('cart'));

    if (items){
      state.items = items;
      state.items.map(item=>{

        var subtotalItem = parseFloat(item.product.precio_mayorista) * item.quantity;
        var subtotal = parseFloat(state.subtotal) + subtotalItem;


          // APLICA DESCUENTOS SI EXISTEN
          state.user.discounts.forEach((el) => {
              if( el.t === 'percent'){
                  if( subtotal > el.gt && subtotal <= el.lt ){
                      state.discount_value = ((el.d * subtotal) / 100);
                      //console.log("Descuento aplicado > "+el.d+"%");
                      //console.log("Descuento aplicado > $ "+state.discount_value);
                  }
              }
          });

          state.subtotal = subtotal;
          state.total = subtotal - state.discount_value;

      });
    }
  },
  [EDIT_CART_QUANTITY] (store, { item, quantity}) {
    var index = state.items.indexOf(item);
    state.items[index] = item;

    state.total = 0;
    state.subtotal = 0;
    state.discount_value = 0;
    state.items.map(item=>{

        //var total = parseFloat(item.product.precio_mayorista) * item.quantity;
        //state.total = parseFloat(state.total) + total;

        var subtotalItem = parseFloat(item.product.precio_mayorista) * item.quantity;
        var subtotal = parseFloat(state.subtotal) + subtotalItem;

        // APLICA DESCUENTOS SI EXISTEN
        state.user.discounts.forEach((el) => {
            if( el.t === 'percent'){
                if( subtotal > el.gt && subtotal <= el.lt ){
                    state.discount_value = ((el.d * subtotal) / 100);
                    console.log("Descuento aplicado > "+el.d+"%");
                    console.log("Descuento aplicado > $ "+state.discount_value);
                }
            }
        });


        state.subtotal = subtotal;
        state.total = subtotal - state.discount_value;


    });

    localStorage.setItem('cart', JSON.stringify(state.items));

  },
  [REMOVE_FROM_CART] (store, { product }) {
        //var totalItemRemoved = parseFloat(product.product.precio_mayorista) * product.quantity;

        var subtotalItemRemoved = parseFloat(product.product.precio_mayorista) * product.quantity;
        var subtotal = parseFloat(state.subtotal) - subtotalItemRemoved;
        state.discount_value = 0;

      // APLICA DESCUENTOS SI EXISTEN
      state.user.discounts.forEach((el) => {
          if( el.t === 'percent'){
              if( subtotal > el.gt && subtotal <= el.lt ){
                  state.discount_value = ((el.d * subtotal) / 100);
                  console.log("Descuento aplicado > "+el.d+"%");
                  console.log("Descuento aplicado > $ "+state.discount_value);
              }
          }
      });


      state.subtotal = subtotal;
      state.total = subtotal - state.discount_value;

    //state.total = state.total - total;
    state.items.splice(state.items.indexOf(product), 1);
    localStorage.setItem('cart', JSON.stringify(state.items));
  },
  [ATTACH_SHIPMENT_INFO](store,{shipment}){
    state.shipment.envio_observacion = shipment.envio_observacion;
    state.shipment.forma_envio = shipment.forma_envio;
  },
  [ADD_TO_CART] (store, { product, quantity}) {
    var record = state.items.find(p => p.product.id === product.id);


    if (!record) {
      state.items.push({product, quantity: quantity});
    } else {

      var newQuantity = parseInt(parseInt(record.quantity) + parseInt(quantity));

      if (record.product.stock_unico<newQuantity)
        return false;

      record.quantity = parseInt(parseInt(record.quantity) + parseInt(quantity));
    }

    state.total = 0;
    state.subtotal = 0;
    state.discount_value = 0;


    state.items.map(item=>{

        var subtotalItem = parseFloat(item.product.precio_mayorista) * item.quantity;
        var subtotal = parseFloat(state.subtotal) + subtotalItem;

        // APLICA DESCUENTOS SI EXISTEN
        if(state.user.discounts instanceof Array) {
          state.user.discounts.forEach((el) => {
            if (el.t === 'percent') {
              if (subtotal > el.gt && subtotal <= el.lt) {
                state.discount_value = ((el.d * subtotal) / 100);
                console.log("Descuento aplicado > " + el.d + "%");
                console.log("Descuento aplicado > $ " + state.discount_value);
              }
            }
          });
        }

        // TODO: Get Discounts data from User:
        /* if( subtotal > 9999 && subtotal <= 19999 ){
            console.log("Descuento aplicado > 5%");
            state.discount_value = ((5 * subtotal) / 100);
        }
        if( subtotal > 19999 && subtotal <= 999999999 ){
            console.log("Descuento aplicado > 5%");
            state.discount_value = ((10 * subtotal) / 100);
        } */


        state.subtotal = subtotal;
        state.total = subtotal - state.discount_value;

    });

    localStorage.setItem('cart', JSON.stringify(state.items));
    return true;
  },
  [PROCESS_CART_PURCHASE](store,{}){
    state.total = 0;
    state.subtotal = 0;
      state.discount_value = 0;
    state.items = [];

    state.shipment = {
      forma_envio:'',
        envio_observacion:'',
    };

    state.paymentType = 'TR';
    localStorage.removeItem('cart');
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js